import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from './auth.service';

export const guestGuard: CanActivateFn = () => {

  const authService = inject(AuthService);
  const router = inject(Router);

  // Token nahi hai → login page allow
  if (!authService.hasToken()) {
    return true;
  }

  // Token hai → backend se validate
  return authService.validateToken().pipe(

    map(() => {

      // Token valid
      return router.parseUrl('/dashboard');
    }),

    catchError(() => {

      // Token invalid / expired
      authService.clearSession();

      return of(true);
    })
  );
};